import { deleteComment } from '../../actions/delete-comment';
import { openSettingsDialog } from '../../actions/open-settings-dialog';
import { reportComment } from '../../actions/report-comment';
import { reportPost } from '../../actions/report-post';
import messages, * as messageTypes from '../../components/message/messages';
import {
  MODAL_TYPE_DELETE_POST,
  MODAL_TYPE_DELETE_COMMENT,
  MODAL_TYPE_REPORT_COMMENT,
  MODAL_TYPE_REPORT_POST,
  MODAL_TYPE_DEMO_MODE,
} from '@wix/communities-blog-client-common';
import { handlePostDelete } from '../../services/handle-post-delete';

export default {
  [MODAL_TYPE_DELETE_POST]: handlePostDelete(),

  [MODAL_TYPE_DELETE_COMMENT]: (payload, { showMessage }) => (dispatch) => {
    return dispatch(
      deleteComment({
        postId: payload.postId,
        commentId: payload.commentId,
        post: payload.post,
        contextToken: payload.contextToken,
      }),
    ).then(() =>
      showMessage(messages[messageTypes.COMMENT_DELETE].content(), messages[messageTypes.COMMENT_DELETE].type),
    );
  },

  [MODAL_TYPE_REPORT_COMMENT]: (report) => reportComment(report),

  [MODAL_TYPE_REPORT_POST]: (report) => reportPost(report),

  [MODAL_TYPE_DEMO_MODE]: (data) => (dispatch) => {
    if (data) {
      dispatch(openSettingsDialog());
    }
  },
};
